/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Traces_Filters_ClearInputs */

const es_admin_traces_filters_clear = /** @type {(inputs: Admin_Traces_Filters_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limpiar`)
};

const en_admin_traces_filters_clear = /** @type {(inputs: Admin_Traces_Filters_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear`)
};

/**
* | output |
* | --- |
* | "Clear" |
*
* @param {Admin_Traces_Filters_ClearInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_traces_filters_clear = /** @type {((inputs?: Admin_Traces_Filters_ClearInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Traces_Filters_ClearInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_traces_filters_clear(inputs)
	return en_admin_traces_filters_clear(inputs)
});
export { admin_traces_filters_clear as "admin.traces.filters.clear" }